import React from 'react';

import { FIND_APPOINTMENT, CLIENT_INFORMATION } from './formSections';

import SelfGuidedPreferenceSvg from '../components/Svg/SelfGuidedPreference';
import LiveVideoPreferenceSvg from '../components/Svg/LiveVideoPreference';
import InPersonPreferenceSvg from '../components/Svg/InPersonPreference';

export const NONE = 'SELECT-OPTION-NO-VALUE';
export const WIDGET_TYPE_LEAD_CAPTURE = 'lead_capture';
export const WIDGET_TYPE_LEAD_CAPTURE_APPOINTMENT = 'lead_capture_appointment';

export const WIDGET_TYPES = [WIDGET_TYPE_LEAD_CAPTURE, WIDGET_TYPE_LEAD_CAPTURE_APPOINTMENT];

export const WIDGET_INITIAL_SECTIONS = {
    [WIDGET_TYPE_LEAD_CAPTURE]: CLIENT_INFORMATION,
    [WIDGET_TYPE_LEAD_CAPTURE_APPOINTMENT]: FIND_APPOINTMENT,
};

export const INVALID_CONFIG_MESSAGE = (
    <span>
        <strong>Invalid Configuration</strong>
    </span>
);
export const MISSING_WIDGET_TYPE_MESSAGE = 'Widget type not configured.';
export const INVALID_WIDGET_TYPE_MESSAGE = 'Invalid widget type';
export const INVALID_CUSTOM_COLOR_MESSAGE = (
    <span>
        <strong>Invalid Custom Color.</strong> Custom color must be a valid 3 or 6 character hex color string,{' '}
        <em>e.g. ff0000 or 333</em>
    </span>
);

const SAVE_BUTTON_TEXT_LEAD_CAPTURE = 'Request Information';
const SAVE_BUTTON_TEXT_LEAD_CAPTURE_APPOINTMENT = 'Make Appointment';

export const WIDGET_TYPE_SAVE_BUTTON_TEXT = {
    [WIDGET_TYPE_LEAD_CAPTURE]: SAVE_BUTTON_TEXT_LEAD_CAPTURE,
    [WIDGET_TYPE_LEAD_CAPTURE_APPOINTMENT]: SAVE_BUTTON_TEXT_LEAD_CAPTURE_APPOINTMENT,
};

const REQUIRED = 10;
const NOT_REQUIRED = 20;
const HIDDEN = 30;
export const EMPLOYEEGROUP_FIELD_CONFIG_CHOICES = {
    REQUIRED,
    NOT_REQUIRED,
    HIDDEN,
};

export const LAUNDRY_IN_UNIT = 10;
export const LAUNDRY_IN_BUILDING = 20;

export const OUTDOOR_SPACE_PRIVATE = 10;
export const OUTDOOR_SPACE_PUBLIC = 20;

export const DOORMAN_ANY = 10;

export const PARKING_ANY = 10;

const AMENTIY_ARRAY_FIELDS = ['outdoor_space', 'laundry'];

export const formatAmenityField = (fieldName, value) => {
    const arr = [fieldName, value];
    if (AMENTIY_ARRAY_FIELDS.indexOf(fieldName) > -1) {
        arr.push('arr');
    }

    return arr.join(':');
};

export const AMENITY_CHOICES = [
    { name: 'doorman', value: formatAmenityField('doorman', DOORMAN_ANY), label: 'Full-time Doorman' },
    { name: 'elevator', value: formatAmenityField('elevator', true), label: 'Elevator' },
    { name: 'laundry', value: formatAmenityField('laundry', LAUNDRY_IN_UNIT), label: 'Laundry in Unit' },
    { name: 'laundry', value: formatAmenityField('laundry', LAUNDRY_IN_BUILDING), label: 'Laundry in Building' },
    {
        name: 'outdoor_space',
        value: formatAmenityField('outdoor_space', OUTDOOR_SPACE_PRIVATE),
        label: 'Private Outdoor Space',
    },
    {
        name: 'outdoor_space',
        value: formatAmenityField('outdoor_space', OUTDOOR_SPACE_PUBLIC),
        label: 'Public Outdoor Space',
    },
    { name: 'parking', value: formatAmenityField('parking', PARKING_ANY), label: 'Parking' },
];

export const PET_CHOICES = [
    { name: 'NO_PETS', value: NONE, label: 'No Pets' },
    { name: 'PETS_CATS', value: 10, label: 'Cats' },
    { name: 'PETS_SMALL_DOGS', value: 20, label: 'Small Dogs' },
    { name: 'PETS_LARGE_DOGS', value: 30, label: 'Large Dogs' },
];

export const BUDGET_CHOICES = [
    500, 750, 1000, 1250, 1500, 1750, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000, 7000, 8000, 9000, 10000, 11000,
    12500, 15000,
].map(price => ({ value: price, label: `$${price}` }));

export const DEFAULT_ACCENT_COLOR = '309EDC';
export const UPDATED_DEFAULT_ACCENT_COLOR = '3F986F';

export const ERROR_RESPONSE_TYPE_START = 'start';
export const ERROR_RESPONSE_TYPE_OTHER = 'other';

export const SMS_OPT_IN_MARKETING_ENABLED = 5;
export const SMS_OPT_IN_MARKETING_DISABLED = 10;
export const SMS_OPT_IN_CLIENT_OPTED_OUT = 30;

export const MARKETING_OPT_IN_OPTED_IN = 10;
export const MARKETING_OPT_IN_OPTED_OUT = 20;
export const MARKETING_OPT_IN_CLIENT_OPTED_OUT = 30;

export const APPOINTMENT_STATUS_CONFIRMED = 30;
export const APPOINTMENT_STATUS_CANCELLED = 40;

export const APPOINTMENT_TOUR_TYPE_GUIDED = 10;
export const APPOINTMENT_TOUR_TYPE_SELF_GUIDED = 20;

export const APPOINTMENT_TOUR_TYPE_GUIDED_TEXT_VALUE = 'guided';
export const APPOINTMENT_TOUR_TYPE_SELF_GUIDED_TEXT_VALUE = 'self-guided';

export const SELF_GUIDED_TOUR_PROVIDER_GENERIC = 10;

export const NEARBY_COMMUNITY_SCHEDULING_TIME_DELTA_IN_MINUTES_FROM_PREVIOUS_APPOINTMENT = 30;

export const GUIDED_OPTION_V1 = {
    value: APPOINTMENT_TOUR_TYPE_GUIDED_TEXT_VALUE,
    label: 'In Person',
    helperText: 'Tour this community with a leasing consultant.',
};

export const SELF_GUIDED_OPTION_V1 = {
    value: APPOINTMENT_TOUR_TYPE_SELF_GUIDED_TEXT_VALUE,
    label: 'Self Guided',
    helperText: 'Tour at your convenience by taking a self-guided tour of this community.',
};

export const VIDEO_OPTION_V1 = {
    value: 'video',
    label: 'Live Video',
    helperText: 'Tour the community from the comfort of your home via video chat.',
};

export const GUIDED_TOUR_OPTION_V2 = {
    value: APPOINTMENT_TOUR_TYPE_GUIDED,
    label: 'In Person',
    helperText: 'Tour this community with a leasing consultant.',
};

export const SELF_GUIDED_TOUR_OPTION_V2 = {
    value: APPOINTMENT_TOUR_TYPE_SELF_GUIDED,
    label: 'Self Guided',
    helperText: 'Tour at your convenience by taking a self-guided tour of this community.',
};

export const VIDEO_GUIDED_TOUR_OPTION_V2 = {
    value: 'video',
    label: 'Live Video',
    helperText: 'Tour the community from the comfort of your home via video chat.',
};

export const GUIDED_TOUR_OPTION_V3 = {
    value: APPOINTMENT_TOUR_TYPE_GUIDED,
    icon: <InPersonPreferenceSvg />,
    label: 'In-person',
    helperText: 'Tour this community with a leasing consultant.',
};

export const SELF_GUIDED_TOUR_OPTION_V3 = {
    value: APPOINTMENT_TOUR_TYPE_SELF_GUIDED,
    icon: <SelfGuidedPreferenceSvg />,
    label: 'Self guided',
    helperText: 'Tour at your convenience by taking a self-guided tour of this community.',
};

export const VIDEO_GUIDED_TOUR_OPTION_V3 = {
    value: 'video',
    icon: <LiveVideoPreferenceSvg />,
    label: 'Live video',
    helperText: 'Tour the community from the comfort of your home via video chat.',
};
